angular.module('impactx.demandbundle').service('DemandBundleService', [
    'dataGen',
    '$redirect',
    '$route',
    '$mdDialog',
    'ToastService',
    '$context',
    DemandBundleService]);

function DemandBundleService(dataGen, $redirect, $route, $mdDialog, ToastService, $context) {
    var ctrl = this;

    this.getUnbundledItems = function (items) {
        var unbundledItemIds = [];
        angular.forEach(items, function (item) {
            if (!item.bundleStatus && item.needsDispatch) {
                unbundledItemIds.push(item.id);
            }
        });
        return unbundledItemIds;
    };

    this.getUnbundledItemsWhole = function (items) {
        var unbundledItemIds = [];
        angular.forEach(items, function (item) {
            if (!item.bundleStatus && item.needsDispatch) {
                unbundledItemIds.push(item);
            }
        });
        return unbundledItemIds;
    };

    this.denyItems = function (deiIds, withRedirect, withRefresh) {
        dataGen.postAsForm({}, {deiIds: deiIds}, "/demandbundle/denyitems").then(function (data) {
            if (withRedirect) {
                $redirect.redirectTo(null, "/demandbundlelist");
            }
            else if (withRefresh) {
                $route.reload();
            }
            ToastService.openStandardToast(data.trns.saveSuccess);
        });
    };

    this.bundleAndAddToBasketRequest = function(result, bkhId, withControl, withRedirect, withRefresh, withMaterialGroupMapping,
                                         copyHeaderComments, copyItemComments, ogdInfoHandling, spoInfoHandling) {
        return dataGen.postAsForm({}, {
            bkhId: bkhId,
            demandItems: result,
            withControl: withControl,
            withMaterialGroupMapping: withMaterialGroupMapping,
            copyHeaderComments: copyHeaderComments,
            copyItemComments: copyItemComments,
            ogdInfoHandling: ogdInfoHandling,
            spoInfoHandling: spoInfoHandling
        }, "/demandbundle/bundleandaddtobasket").then(function (data) {
            if (withRedirect) {
                $redirect.redirectTo(null, "/demandbundlelist");
            }
            else if (withRefresh) {
                $route.reload();
            }
            $context.refreshBasket({}, dataGen, $context);
            ToastService.openStandardToast(data.trns.saveSuccess);
        });
    };

    this.denyHeader = function (dehId, withRedirect, withRefresh) {
        dataGen.postAsForm({}, {dehId: dehId}, "/demandbundle/denyheader").then(function (data) {
            if (withRedirect) {
                $redirect.redirectTo(null, "/demandbundlelist");
            }
            else if (withRefresh) {
                $route.reload();
            }
            ToastService.openStandardToast(data.trns.saveSuccess);
        });
    };

    this.showAddToBasketDialog = function (event, deiIds, hasControl, toCurrentBasket, withRedirect, withRefresh, hasItemComments, hasMaterialGroupMappings,
                                           hasHeaderComments, hasOGDInfo, hasSPOInfo) {
        $mdDialog.show({
            controller: "DemandBundleAddDialogCtrl",
            controllerAs: "demandBundleAddDialogCtrl",
            templateUrl: "modules/demandbundle/templates/demandbundleadddialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                noControlPreSet: !hasControl,
                noBasketPreSet: !toCurrentBasket,
                noMaterialGroupMappingPreSet: !hasMaterialGroupMappings,
                hasItemComments: hasItemComments,
                hasHeaderComments: hasHeaderComments,
                hasOGDInfo: hasOGDInfo,
                hasSPOInfo: hasSPOInfo
            }
        })
            .then(function (answer) {
                ctrl.bundleAndAddToBasketRequest(deiIds, answer.bkhId, answer.withControl, withRedirect, withRefresh, answer.withMaterialGroupMapping, answer.copyHeaderComments,
                    answer.copyItemComments, answer.ogdInfoHandling , answer.spoInfoHandling);
            }, function () {
            });
    }
}